import { failureAction, successAction, startAction } from '../../common'
import {
  DELETE_PAIRING,
  RESET_DELETE_PAIRING,
} from '../types'

export const initialState = {
  deleting: false,
  deleted: false,
  error: {},
}

const reducer = ({ delete: state }, action) => {
  switch (action.type) {
    case startAction(DELETE_PAIRING):
      return {
        ...state,
        deleting: true,
        deleted: false,
        error: {},
      }
    case successAction(DELETE_PAIRING):
      return {
        ...state,
        deleting: false,
        deleted: true,
        error: {},
      }
    case failureAction(DELETE_PAIRING):
      return {
        ...state,
        deleting: false,
        deleted: false,
        error: action.payload,
      }

    case RESET_DELETE_PAIRING:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default reducer
